'use client';
import React from 'react';
import Navbar from '@/components/portfolio/Navbar';
import NavbarSticky from '@/components/portfolio/NavbarSticky';
import HeroSection from '@/components/portfolio/HeroSection';
import AboutSection from '@/components/portfolio/AboutSection';
import SkillSection from '@/components/portfolio/SkillSection';
import PortfolioSection from '@/components/portfolio/PortfolioSection';
import ContactSection from '@/components/portfolio/ContactSection';
import Footer from '@/components/portfolio/Footer';
import BlogSection from '@/components/portfolio/BlogSection';

export default function HomePage() {
  return (
    <div
      className="min-h-screen"
      style={{
        backgroundColor: '#8EC5FC',
        backgroundImage: 'linear-gradient(62deg, #8EC5FC, #E0C3FC)',
      }}
    >
      {/* Floating sticky navbar — appears after scrolling 240px */}
      <NavbarSticky />

      <main className="container max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-20 space-y-14">
        {/* Home Section — white card with static navbar at top */}
        <section
          id="home"
          className="bg-white shadow-lg rounded-3xl p-4 sm:p-6 lg:p-8 lg:mt-14"
        >
          <Navbar />
          <HeroSection />
        </section>

        {/* About Section */}
        <AboutSection />

        {/* Skill Section */}
        <SkillSection />

        {/* Portfolio Section */}
        <PortfolioSection />

        {/* Blog Section */}
        <BlogSection />

        {/* Contact Section */}
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
}
